import common from 'constants/common';
import { w3cwebsocket as W3CWebSocket } from 'websocket';
import dataService from '../dataService';
import { API_SOCKET_TOKEN } from '../dataService/resources';

const wsUrl = process.env.REACT_APP_WS;

const getQueryStringValues = (url, key) => {
  const arrParamValues = [];
  const slicedUrl = url.slice(url.indexOf('?') + 1).split('&');

  for (let i = 0; i < slicedUrl.length; i++) {
    const arrParamInfo = slicedUrl[i].split('=');

    if (arrParamInfo[0] === key || arrParamInfo[0] === `${key}[]`) {
      arrParamValues.push(decodeURIComponent(arrParamInfo[1]));
    }
  }

  if (arrParamValues.length > 0) {
    return arrParamValues.length === 1 ? arrParamValues[0] : arrParamValues;
  }

  return null;
};

class WsService {
  constructor() {
    this.callbacks = {};
  }

  on(name, callback) {
    this.callbacks[name] = callback;
  }

  emit(name, data) {
    if (!this.callbacks[name]) return;
    this.callbacks[name](data);
  }

  off(name) {
    delete this.callbacks[name];
  }

  async connect() {
    const timeoutMilliseconds =
      common.websocketTokenTimeout * 60 * 1000 - 10000;
    const token = await this.getToken();
    this.client = new W3CWebSocket(`${wsUrl}?token=${token}`);
    this.client.onerror = () => {
      console.log('Connection Error');
    };
    this.client.onopen = () => {
      console.log('WebSocket Connection Established');
    };
    this.client.onclose = () => this.connect();
    this.client.onmessage = (event) => {
      const { type, data } = JSON.parse(event.data);
      this.emit(type, data);
    };
    setTimeout(() => this.client.close(), timeoutMilliseconds);
  }

  async getToken() {
    const { error, data } = await dataService.getOnly(API_SOCKET_TOKEN);
    if (!error) return data.token;
  }

  send(action, data) {
    try {
      const postData = {
        ...data,
        token: getQueryStringValues(this.client.url, 'token'),
      };
      this.client.send(JSON.stringify({ action, postData }));
    } catch (e) {
      console.log('[WS SEND ERROR] action: ', action, 'error: ', e);
    }
  }

  disconnect() {
    if (this.client) {
      this.client.onclose = null;
      this.client.close();
    }
  }
}
const wsService = new WsService();
export default wsService;

export const NEW_READING_EVENT = 'newReading';
export const REPORT_READY_EVENT = 'sendReportLink';
export const ON_CALL_EVENT = 'onCall';
export const ON_CALL_INIT_EVENT = 'callInit';
export const ON_CALL_ENDED_EVENT = 'callEnded';
export const ERROR = 'error';
export const NEW_RESERVED_READING_EVENT = 'newReservedReading';
export const CLEAR_RESERVED_READINGS_EVENT = 'clearReservedReadings';
